export default {
  doesIncludeSetpoints: 'Pokaż każdą wartość zadaną z jej tolerancjami',
  doesIncludeSignalLegend: 'Wymień wyjścia cyfrowe i warunki pod krokami',
};
